export default __webpack_public_path__ + "static/media/003_BANNER_TECNOLOGIA_MOTOR_BANNER_01.46b4e70e.jpg";